import React, { createContext, ReactNode, useContext, useState } from "react";

export enum ModalType {
  textColor = "textColor",
  font = "font",
  textSize = "textSize",
  layout = "layout",
  zoom = "zoom",
  background = "background",
  signature = "signature",
  textGenerator = "textGenerator",
  aItextGenerator = "aItextGenerator",
}

interface ModalContextInterface {
  show: boolean;
  toggleShow: (boolean: boolean, data: null | string, modalType: ModalType) => void;
  data: string | null;
  type: ModalType;
}

export const useModal = () => {
  return useContext(ModalContext);
}

export const ModalContext = createContext<ModalContextInterface>({
  show: false,
  toggleShow: () => {},
  data: null,
  type: ModalType.font
});

export const ModalProvider = ( { children }: {children: ReactNode}) => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState<string | null>(null);
  const [type, setType] = useState<Partial<ModalType>>( ModalType.font);

  const toggleShow = (boolean: boolean, data: null | string, modalType: ModalType) => {
    setShow(boolean);
    setData(data);
    setType(modalType)
  }

  return (
    <ModalContext.Provider value={{ show, toggleShow, data, type }}>
      { children }
    </ModalContext.Provider>
  )
}

